<template>
  <div class="page-wrap">
    <div class="filter">
      <div class="header-text">广告收入报表</div>
      <el-form ref="formRef" inline style="display: flex; flex-wrap: wrap">
        <div v-for="(item, name) in selectValue" :key="name" class="filter-item">
          <el-form-item v-if="item.type === 'date'">
            <el-date-picker
              style="width: 288px"
              v-model="selectValue[name].value"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              :clearable="false"
            />
          </el-form-item>
          <el-form-item v-else-if="item.type === 'geo'">
            <areaMultiSelect
              class="hiddenClass"
              style="width: 288px"
              :value.sync="selectValue[name].value"
              :optionsList="selectDataList[name]"
              labelKey="label"
              valueKey="value"
            >
            </areaMultiSelect>
          </el-form-item>
          <el-form-item v-else-if="item.type === 'appId'">
            <el-select
              collapse-tags
              @change="changeSelectOptionn(item.type, name, selectValue[name].value)"
              v-model="selectValue[name].value"
              style="width: 288px"
              class="hiddenClass"
              popper-class="summary-report-income-select-popper"
              :multiple="true"
              filterable
              :filter-method="filterOptions"
              placeholder="请选择应用"
            >
              <el-option
                v-for="item in appIdList"
                :key="item.value"
                :value="item.value"
                :title="item.label"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else>
            <el-select
              collapse-tags
              @change="changeSelectOptionn(item.type, name, selectValue[name].value)"
              v-model="selectValue[name].value"
              style="width: 288px"
              class="hiddenClass"
              popper-class="summary-report-income-select-popper"
              :multiple="item.type === 'multiple' ? true : false"
              filterable
            >
              <el-option
                v-for="item in selectDataList[name]"
                :key="item.value"
                :value="item.value"
                :title="item.label"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-button size="medium" type="primary" @click="searchList">查询</el-button>
      </el-form>
    </div>

    <div class="content">
      <div class="button-form">
        <span style="color: rgba(0, 0, 0, 0.85); font-size: 14px">显示曲线：</span>
        <el-switch checked-children="开启" un-checked-children="关闭" v-model="showCharts" />
        <el-button
          size="mini"
          icon="el-icon-remove-outline"
          style="margin-left: 16px"
          @click="clearChart"
          >清空曲线</el-button
        >
      </div>
      <div v-show="showCharts" class="charts-area" ref="chartRef" v-loading="chartLoading"></div>
      <div style="text-align: right; margin-bottom: 10px">
        <el-button type="primary" @click="downLoadFileToExcel">导出报表</el-button>
      </div>
      <div class="table-wrap" :class="showCharts ? 'show-table-wrap' : ''">
        <el-table
          id="rebateSetTable"
          ref="table"
          :max-height="610"
          :data="
            tableData.slice((pageData.page - 1) * pageData.size, pageData.page * pageData.size)
          "
          :show-summary="tableData.length > 0"
          :summary-method="getSummaries"
          @sort-change="changeSort"
          v-loading="tableLoading"
        >
          <el-table-column
            v-for="item in filterColumnsData"
            :key="item.dataIndex"
            :prop="item.dataIndex"
            :label="item.title"
            :sortable="item.sorter"
          >
            <template slot-scope="scope"> {{ scope.row[item.dataIndex] }}</template>
          </el-table-column>
        </el-table>
        <self-pagination
          class="table-pagination"
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="handleSizeChange"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { selectDataList, getTableColumns, getAllSelectList, changeAppOption } from "./config";
import * as echarts from "echarts";
import { downLoadWrokSheet } from "@/utils/commonTools";
import { changeshortcutclass, clearallshortcutclass, dataSortCompare } from "@/utils/tool";
import { getIncomeGetTableData, getIncomeGetChartData, getIncomeGetPros } from "@/api/summery";
import areaMultiSelect from "@/components/areaMultiSelect.vue";

export default {
  components: {
    areaMultiSelect,
  },

  data() {
    return {
      selectDataList,
      tableColumns: [],
      selectValue: {
        appId: { name: "应用", value: [], type: "appId" },
        appVer: { name: "应用版本", value: [-1], type: "multiple" },
        country: { name: "国家和地区", value: [], type: "geo" },
        chnl: { name: "渠道", value: [-1], type: "multiple" },
        oriChnl: { name: "原始渠道", value: [-1], type: "multiple" },
        mainDim: { name: "时间维度", value: 2 },
        subDim: { name: "展示维度", value: -1 },
        datePicker: {
          name: "日期",
          value: [
            moment().subtract(7, "days").format("YYYY-MM-DD"),
            moment().subtract(1, "days").format("YYYY-MM-DD"),
          ],
          type: "date",
        },
        hiddenCol: { name: "隐藏项", value: [-1], type: "multiple" },
      },
      appIdList: [],
      allAppIdList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function () {
          clearallshortcutclass(this.$el);
        },
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
      },
      showCharts: true,
      myChart: null,
      tableLoading: false,
      chartLoading: false,
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      tableData: [],
      resData: {},
    };
  },

  computed: {
    filterColumnsData() {
      const selectHiddenCols = this.selectValue.hiddenCol.value;
      const cols = this.tableColumns.filter((item) => {
        if (selectHiddenCols.length === 1 && selectHiddenCols[0] === -1) {
          //默认
          return true;
        } else {
          return selectHiddenCols.includes(item.dataIndex) ? false : true;
        }
      });
      return cols;
    },
  },

  watch: {},

  async mounted() {
    await getAllSelectList();
    this.tableColumns = await getTableColumns(this.selectValue);
    this.getTableData();
    this.initCharts();
    this.renderData();
    getIncomeGetPros().then((res) => {
      let arr = res.data.map((item) => {
        item.label = item.appName + "(" + item.pkg + ")";
        item.value = item.adConfId;
        return item;
      });
      this.appIdList = arr;
      this.allAppIdList = arr;
    });
  },

  methods: {
    // 查询
    async searchList() {
      this.tableColumns = await getTableColumns(this.selectValue);
      this.getTableData();
      this.renderData();
    },

    getTableData() {
      this.tableLoading = true;
      const { appId, appVer, country, chnl, oriChnl, mainDim, subDim, datePicker } =
        this.selectValue;
      getIncomeGetTableData({
        adConfId: appId.value?.join(",") === "-1" ? "" : appId.value?.join(","),
        datePicker: datePicker.value?.join(","),
        mainDim: mainDim.value,
        subDim: subDim.value === -1 ? "" : subDim.value,
        appVer: appVer.value?.join(",") === "-1" ? "" : appVer.value?.join(","),
        chnl: chnl.value.join(",") === "-1" ? "" : chnl.value?.join(","),
        oriChnl: oriChnl.value.join(",") === "-1" ? "" : oriChnl.value?.join(","),
        geo: country.value.join(","),
      }).then((res) => {
        this.resData = res;
        this.tableData = res.results || [];
        this.pageData.total = this.tableData.length;
        this.pageData.page = 1;
        this.tableLoading = false;
      });
    },

    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        switch (column.property) {
          case "showCnt":
            sums[index] = this.resData.showCnt || "0";
            break;
          case "dau":
            sums[index] = (this.resData.dau || "0") + "人";
            break;
          case "showAvgDau":
            sums[index] = (this.resData.showAvgDau || "0") + "次/人";
            break;
          case "income":
            sums[index] = (this.resData.income || "0") + "元";
            break;
          case "incomeCny":
            sums[index] = (this.resData.incomeCny || "0") + "元";
            break;
          case "ecpm":
            sums[index] = (this.resData.ecpm || "0") + "元/千次";
            break;
          case "ecpmCny":
            sums[index] = (this.resData.ecpmCny || "0") + "元/人";
            break;
          case "arpu":
            sums[index] = (this.resData.arpu || "0") + "元/人";
            break;
          case "arpuCny":
            sums[index] = (this.resData.arpuCny || "0") + "(人民币)/人";
            break;
        }
      });
      return sums;
    },

    filterOptions(value) {
      this.appIdList = this.allAppIdList.filter((item) => {
        let valueStr = String(value);
        return (
          item.label.toLowerCase().includes(valueStr.toLowerCase()) ||
          item.value.toLowerCase().includes(valueStr.toLowerCase()) ||
          item.dbtId?.toLowerCase().includes(valueStr.toLowerCase())
        );
      });
    },

    changeSort({ prop, order }) {
      this.tableData = this.tableData.sort((a, b) => {
        return dataSortCompare(a, b, order, prop, "resDate");
      });
    },

    downLoadFileToExcel() {
      const { arpu, arpuCny, dau, ecpm, ecpmCny, income, incomeCny, showAvgDau, showCnt } =
        this.resData;
      const data = JSON.parse(JSON.stringify(this.tableData));
      data.push({
        resDate: "总计",
        arpu: arpu + "元/人",
        arpuCny: arpuCny + "(人民币)/人",
        dau: dau + "人",
        ecpm: ecpm + "元/千次",
        ecpmCny: ecpmCny + "元/人",
        income: income + "元",
        incomeCny: incomeCny + "元",
        showAvgDau: showAvgDau + "次/人",
        showCnt: showCnt,
      });
      const haderData = {};
      this.filterColumnsData.forEach((item) => {
        haderData[item.dataIndex] = item.title;
      });
      downLoadWrokSheet(data, "广告收入报表.xlsx", haderData);
    },

    clearChart() {
      let chartDom = this.$refs.chartRef;
      let myChart = echarts.init(chartDom);
      let option = myChart.getOption();
      let dataList = option.legend[0].data;
      let legendList = {};
      for (var int = 0; int < dataList.length; int++) {
        legendList[dataList[int]] = false;
      }
      option.legend[0].selected = legendList;
      myChart.clear();
      myChart.setOption(option);
      this.$nextTick(() => {
        myChart.resize();
      });
    },

    initCharts() {
      let chartDom = this.$refs.chartRef;
      let myChart = echarts.init(chartDom);
      window.onresize = myChart.resize;
      this.myChart = myChart;
    },
    async renderData() {
      this.chartLoading = true;
      const { appId, appVer, country, chnl, mainDim, datePicker } = this.selectValue;
      const res = await getIncomeGetChartData({
        adConfId: appId.value?.join(",") === "-1" ? "" : appId.value?.join(","),
        datePicker: datePicker.value?.join(","),
        mainDim: mainDim.value,
        appVer: appVer.value?.join(",") === "-1" ? "" : appVer.value?.join(","),
        chnl: chnl.value.join(",") === "-1" ? "" : chnl.value?.join(","),
        geo: country.value.join(","),
      });
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,0.6)",
          textStyle: {
            color: "white", //设置文字颜色
          },
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
          "#00B2EE",
          "#CD00CD",
          "#00ff66",
          "#FA8072",
        ],
        legend: {
          top: 10,
          data: res.legendList,
          // x: "center",
          padding: [10, 50, 0, 50],
        },
        grid: {
          top: "50px",
          left: "80px",
          right: "80px",
          bottom: "40px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: res.xAxisList,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#A3A3A3",
              fontSize: 13,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(240, 240, 240, 1)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(240, 240, 240, 1)",
            },
          },
        },
        yAxis: {
          type: "value",
          // name: "展示数",
          nameTextStyle: {
            color: "rgba(0, 0, 0, 0.64)",
          },
          axisLabel: {
            textStyle: {
              color: "#A3A3A3",
              fontSize: 13,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(240, 240, 240, 1)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(240, 240, 240, 1)",
            },
          },
          axisPointer: {
            snap: true,
          },
        },
        series: res.seriesList.map((item) => {
          return {
            name: item.name,
            type: "line",
            data: item.data,
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
          };
        }),
      };
      this.myChart.clear();
      this.myChart.setOption(option);
      this.chartLoading = false;
    },
    changeSelectOptionn(type, key, value) {
      if (type === "multiple") {
        if (value.length === 2 && value[0] === -1) {
          this.selectValue[key].value = [value[1]];
        }
        if (value[value.length - 1] === -1) {
          this.selectValue[key].value = [-1];
        }
      }
      //广告位和渠道联动
      if (key === "appId") {
        changeAppOption(this.selectValue[key].value);
      }
    },
    changePage(page) {
      this.pageData.page = page;
    },
    handleSizeChange(size) {
      this.pageData.size = size;
      this.pageData.page = 1;
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  width: calc(100vw - 60px);
  padding: 8px 0px 16px 16px;
  .header-text {
    padding-bottom: 8px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .filter {
    width: 100%;
    background: white;
    padding: 16px;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    &-item {
      margin-right: 12px;
      /deep/ .el-range-editor {
        padding: 0 10px;
      }
    }
    .hiddenClass {
      /deep/ .el-tag {
        display: flex;
        max-width: 100%;
        .el-select__tags-text {
          text-overflow: ellipsis;
          overflow: hidden;
          width: 100%;
          display: inline-block;
        }
        .el-tag__close {
          margin-top: 4px;
        }
      }
    }
  }
  .content {
    width: 100%;
    background: white;
    padding: 16px;
    margin-top: 16px;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    margin-bottom: 28px;
    .button-form {
      text-align: right;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .charts-area {
      height: 400px;
    }
    .table-wrap {
      flex: 1;
      /deep/ .el-table__footer-wrapper {
        display: block !important;
      }
    }
  }
}
</style>

<style lang="less">
.summary-report-income-select-popper {
  .el-scrollbar {
    max-width: 400px;
  }
}
</style>
